export default class FKegiatan {
  constructor(
    id,
    kode1,
    description,
    fdivisionBean,
    statusActive,

    tahun,
    namaPekerjaan,
    gantiNamaPaket,
    paketAbt,

    jenisPekerjaan,
    subKegiatan,

    nilaiPagu,
    nilaiKontrak,

    //Pelaksana
    cvptBean,
    nomorKontrak,
    tglKontrak,

    kpaBean,
    pptkBean,
    pengawasBean,

    nomorAdendum,
    tglAdendum,


    //KEMAJUAN
    nomorKemajuan,
    tglKemajuan,
    persenKemajuan,

    //KEMAJUAN
    nomorPenyerahan,
    tglPenyerahan,

    //Hasil Lab
    nomorLab,
    tglLab,
    hasilLab,

    //Permohonan PHO
    nomorPermohonanPho,
    tglPermohonanPho,

    //Kegiatan PHO
    nomorPho,
    tglPho,
    hasilPho,

    //Kegiatan FHO
    nomorFho,
    tglFho,

    //Pencairan Termin 1
    termin1Pemohon,
    tglTermin1Permohonan,
    termin1Cair,
    tglTermin1Cair,

    //Pencairan Termin 2
    termin2Pemohon,
    tglTermin2Permohonan,
    termin2Cair,
    tglTermin2Cair,

    //Pencairan Termin 3
    termin3Pemohon,
    tglTermin3Permohonan,
    termin3Cair,
    tglTermin3Cair,

    fkegiatanTeams,

    lat,
    lon,

    temp_image1_url,
    temp_image2_url,
    /**
     * Temporer
     */
    ketuaBean,
    sekretarisBean,
    anggota1Bean,
    anggota2Bean,
    anggota3Bean,

    avatarImage,
    fkegiatanImages,
    fkegiatanFiles,

    created,
    modified,
    modifiedBy
  ) {
    this.id = id;
    this.kode1 = kode1;
    this.description = description;
    this.statusActive = statusActive;
    this.fdivisionBean = fdivisionBean;

    this.tahun = tahun;
    this.namaPekerjaan = namaPekerjaan;
    this.gantiNamaPaket = gantiNamaPaket;
    this.paketAbt = paketAbt;

    this.nilaiPagu = nilaiPagu;
    this.nilaiKontrak = nilaiKontrak;

    this.jenisPekerjaan = jenisPekerjaan;
    this.subKegiatan = subKegiatan;

    //Pelaksana
    this.cvptBean = cvptBean;
    this.nomorKontrak = nomorKontrak;
    this.tglKontrak = tglKontrak;

    this.kpaBean = kpaBean;
    this.pptkBean = pptkBean;
    this.pengawasBean = pengawasBean;

    this.nomorAdendum = nomorAdendum;
    this.tglAdendum = tglAdendum;


    //KEMAJUAN
    this.nomorKemajuan = nomorKemajuan;
    this.tglKemajuan =tglKemajuan;
    this.persenKemajuan = persenKemajuan;

    //KEMAJUAN
    this.nomorPenyerahan = nomorPenyerahan;
    this.tglPenyerahan = tglPenyerahan;

    //Hasil Lab
    this.nomorLab =nomorLab;
    this.tglLab = tglLab;
    this.hasilLab = hasilLab;

    //Permohonan PHO
    this.nomorPermohonanPho = nomorPermohonanPho;
    this.tglPermohonanPho = tglPermohonanPho;

    //Kegiatan PHO
    this.nomorPho = nomorPho;
    this.tglPho = tglPho;
    this.hasilPho = hasilPho;

    //Kegiatan FHO
    this.nomorFho = nomorFho;
    this.tglFho  = tglFho;

    //Pencairan Termin 1
    this.termin1Permohonan = termin1Pemohon;
    this.tglTermin1Permohonan = tglTermin1Permohonan;
    this.termin1Cair = termin1Cair;
    this.tglTermin1Cair = tglTermin1Cair;


    //Pencairan Termin 2
    this.termin2Pemohon = termin2Pemohon;
    this.tglTermin2Permohonan = tglTermin2Permohonan;
    this.termin2Cair = termin2Cair;
    this.tglTermin2Cair = tglTermin2Cair;

    //Pencairan Termin 3
    this.termin3Pemohon = termin3Pemohon;
    this.tglTermin3Permohonan = tglTermin3Permohonan;
    this.termin3Cair = termin3Cair;
    this.tglTermin3Cair = tglTermin3Cair;

    this.lat = lat;
    this.lon = lon;

    this.temp_image1_url = temp_image1_url;
    this.temp_image2_url = temp_image2_url;

    this.ketuaBean = ketuaBean;
    this.sekretarisBean = sekretarisBean;
    this.anggota1Bean = anggota1Bean;
    this.anggota2Bean = anggota2Bean;
    this.anggota3Bean = anggota3Bean;

    this.avatarImage = avatarImage;
    this.fkegiatanImages = fkegiatanImages;
    this.fkegiatanFiles = fkegiatanFiles;

    this.created = created;
    this.modified = modified;
    this.modifiedBy = modifiedBy;
  }

}
